import { put, select, takeLatest } from 'redux-saga/effects'
import { getProcedureStateSelector } from '../../../../components/procedure/selectors'
import { setInputRows } from '../../../../components/procedure/store/procedure.actions'
import { IProcedureState } from '../../../../components/procedure/store/procedure.types'
import { getRescueSelector } from '../selectors'
import { RescueConstants } from '../store/rescue.constants'
import { IRescueState } from '../store/rescue.types'

export function* setRehab() {
  const procedureState: IProcedureState = yield select(getProcedureStateSelector)
  const rescueState: IRescueState = yield select(getRescueSelector)
  const { inputRows } = procedureState
  const { rehab } = rescueState
  inputRows.map((row) =>
    row.inputs.map((input) => {
      if (input.key === RescueConstants.SET_REHAB) {
        //@ts-ignore
        input.props.savedValues = rehab
      }
    })
  )
  yield put(setInputRows(inputRows))
}

export function* setRehabSaga() {
  yield takeLatest([RescueConstants.SET_REHAB], setRehab)
}
